import { SessionManagerContext, useToastListener } from "@basic/shared";
import { AppRouter as FireflyAppRouter, useIsBootstrapping, useLogger } from "@squide/firefly";
import { useCallback } from "react";
import { Outlet, createBrowserRouter } from "react-router";
import { RouterProvider } from "react-router/dom";
import { Loading } from "./Loading.tsx";
import { RootErrorBoundary } from "./RootErrorBoundary.tsx";
import { ToastContainer, useToastContainer } from "./toast.tsx";
import { useSessionManagerInstance } from "./useSessionManagerInstance.ts";

function BootstrappingRoute() {
    const { toastState, addToast } = useToastContainer();

    const handleShowToast = useCallback((message: string) => {
        addToast(message);
    }, [addToast]);

    useToastListener(handleShowToast);

    const sessionManager = useSessionManagerInstance();

    if (useIsBootstrapping()) {
        return <Loading />;
    }

    return (
        <SessionManagerContext.Provider value={sessionManager}>
            <ToastContainer state={toastState}>
                <Outlet />
            </ToastContainer>
        </SessionManagerContext.Provider>
    );
}

export function AppRouter() {
    const logger = useLogger();

    return (
        <FireflyAppRouter>
            {({ rootRoute, registeredRoutes, routerProviderProps }) => {
                logger
                    .withText("[shell] React Router will be rendered with the following route definitions:")
                    .withObject(registeredRoutes)
                    .debug();

                return (
                    <RouterProvider
                        router={createBrowserRouter([
                            {
                                element: rootRoute,
                                errorElement: <RootErrorBoundary />,
                                children: [
                                    {
                                        element: <BootstrappingRoute />,
                                        children: registeredRoutes
                                    }
                                ]
                            }
                        ])}
                        {...routerProviderProps}
                    />
                );
            }}
        </FireflyAppRouter>
    );
}
